import { Component, EventEmitter, Output, ViewChild, OnInit, Inject } from '@angular/core';
import { IonModal } from '@ionic/angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from '@ridango/core';
import Env from '@ridango/core/env';

@Component({
    selector: 'rwidget-enter-new-card-modal',
    templateUrl: './enter-new-card-modal.component.html',
    styleUrls: ['./enter-new-card-modal.component.scss']
})
export class EnterNewCardModalComponent extends BaseComponent implements OnInit {
    @Output() cardAdded: EventEmitter<number> = new EventEmitter<number>();
    @ViewChild(IonModal) removeTopUpModal: IonModal;

    cardForm: FormGroup;
    cardValidationLength: number;
    isFormSubmitted = false;

    constructor(
        @Inject('ENV') public env: Env,
        private formBuilder: FormBuilder
    ) {
        super();
    }

    ngOnInit(): void {
        this.cardValidationLength = this.env.PURCHASE_FLOW?.UTN_TRAVEL_CARD_LENGTH || 10;

        this.cardForm = this.formBuilder.group({
            cardNumber: ['', [Validators.required, Validators.pattern(`^[0-9]{${this.cardValidationLength}}$`)]]
        });
    }

    openModal(): void {
        this.isFormSubmitted = false;
        this.cardForm.reset();
        this.removeTopUpModal?.present();
    }

    closeModal(): void {
        this.removeTopUpModal.dismiss(null, 'cancel');
    }

    setCardNumber(): void {
        this.isFormSubmitted = true;

        const cardNumber = this.cardForm.get('cardNumber')?.value;

        if (this.cardForm.invalid || !cardNumber) {
            return;
        }

        this.cardAdded.emit(Number(cardNumber));
        this.closeModal();
    }

    shouldShowError(controlName: string, errorType: string): boolean {
        const control = this.cardForm.get(controlName);
        return control?.hasError(errorType) && (control.touched || this.isFormSubmitted);
    }
}
